export const toRGBA = (r: number, g: number, b: number, a?: number) => {
  return `rgba(${r},${g},${b}${!!a ? `,${a}` : ""})`;
};
